import { render, staticRenderFns } from "./KubernetesServiceTab.vue?vue&type=template&id=1005355d&scoped=true&"
import script from "./KubernetesServiceTab.vue?vue&type=script&lang=js&"
export * from "./KubernetesServiceTab.vue?vue&type=script&lang=js&"
import style0 from "./KubernetesServiceTab.vue?vue&type=style&index=0&id=1005355d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005355d",
  null
  
)

export default component.exports